import { useId } from 'react';
import { Textarea } from './textarea';
import { Input } from './input';

// The label must not contain the date picker's buttons or portalled calendar.
export function FormField({ label, help, multiline = false, ...props }) {
  const generatedId = useId();
  const id = props.id || generatedId;
  return <div className="space-y-1 text-sm">
    <label htmlFor={id}>{label}</label>
    {multiline
      ? <Textarea {...props} id={id} aria-describedby={help ? `${id}-help` : undefined} rows={3} />
      : <Input {...props} id={id} aria-describedby={help ? `${id}-help` : undefined} />}
    {help && <p id={`${id}-help`} className="text-xs text-gray-500">{help}</p>}
  </div>;
}
